'use strict';

var $    = require('jquery');
var Core = require('../core/core.js');

/**
 * Creates a Tab
 *
 * @class
 */

class FormTextArea extends Core {

    _defaults() {
        return {
            target: '.js-formtextarea',
            fields: {
                'label': "",
                'placeholder': "",
                'value': "",
                'isReadOnly': false
            }
        };
    }

    constructor(options) {
        super(options);

        this.template = `
            <textarea class='editor__form__textarea js-editor__form__textarea' placeholder="<%- placeholder %>" rows=10><%- value %></textarea>
        `;

        super.render();

        if(options.fields['isReadOnly']) {
            this.$el.attr('disabled', true);
            this.$el.addClass('editor__form__textarea--disabled');
        }
        
        /**
         * Text input
         *
         * @fires FormTextInput#_valuechanged
         */

         this.$el.on('input', this._valuechanged);
    }

    /**
     * @event FormTextInput#Cioui:Form:value
     * @property {String}Cioui:Form:value
     * @returns {String} value - the new text input obj
     */

    _valuechanged(e){
        $(e.currentTarget).trigger('Cioui:Form:value', $(e.currentTarget).val());
    }

    /**
     * setValue
     *
     * @param {string} value - the value that you want to set
     */

    setValue(value){
        this.$el.val(value);
    }

}
module.exports = FormTextArea;